import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface FieldProps {
  label: ReactNode;
  htmlFor: string;
}

// TODO: Make it add id to child.
export const HorizontalField: FC<FieldProps> = ({
  children,
  label,
  htmlFor,
}) => (
  <HorizontalFieldWrapper>
    <Label htmlFor={htmlFor}>{label}</Label>
    {children}
  </HorizontalFieldWrapper>
);

const HorizontalFieldWrapper = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-right: 1em;
  }
`;

const Label = styled.label`
  margin-right: 0.5em;
`;
